import {XHTTP} from '@/shared/xhttp';
import {ProjetService} from "@/xhttp/ProjetService";
import {Client} from "@/models/Client";
import {Tache} from "@/models/Tache";

@XHTTP(ProjetService, '/projets')
export class Projet {

	private _id: number;
	private _name: string;
	private _description: string;
	private _cloture: boolean;
	private _client: Client;
	private _taches: Tache[] = [];
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get description(): string {
		return this._description;
	}

	public get cloture(): boolean {
		return this._cloture;
	}

	public get client(): Client {
		return this._client;
	}

	public get taches(): Tache[] {
		return this._taches;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set name(value: string) {
		this._name = value;
	}

	public set description(value: string) {
		this._description = value;
	}

	public set cloture(value: boolean) {
		this._cloture = value;
	}

	public set client(value: Client) {
		this._client = value;
	}

	public set taches(value: Tache[]) {
		this._taches = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			description     : this._description,
			cloture  : this._cloture,
			client  : this._client ? this._client.id : null,
			tache: this._taches ? this._taches.map(r => r.toJSON()) : [],
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._description      = data.description;
		this._cloture   = data.cloture;
		this._client    = data.client ? (new Client()).fromJSON(data.client) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		this._taches = data.taches ? data.taches.map(r => (new Tache()).fromJSON(r)) : [];
		return this;
	}
}